import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import VariableConst from 'components/variable/variable-const';

const VariablesRoute: React.FC = () =>
{
    return (
        <Routes>
            <Route path="/" element={
                <PermissionGuard permission={VariableConst.permissions.VIEW} fallback={<Pages.Page403 />}>
                    <Pages.VariableGroup />
                </PermissionGuard>
            } />
            <Route path="/page/:pageNum" element={
                <PermissionGuard permission={VariableConst.permissions.VIEW} fallback={<Pages.Page403 />}>
                    <Pages.VariableGroup />
                </PermissionGuard>
            } />
            <Route path="/page" element={
                <PermissionGuard permission={VariableConst.permissions.VIEW} fallback={<Pages.Page403 />}>
                    <Pages.VariableGroup />
                </PermissionGuard>
            } />
            <Route path="/:group/*" element={
                <PermissionGuard permission={VariableConst.permissions.VIEW} fallback={<Pages.Page403 />}>
                    <Pages.VariableList />
                </PermissionGuard>
            } />
            <Route path="/create/*" element={
                <PermissionGuard permission={VariableConst.permissions.VIEW} fallback={<Pages.Page403 />}>
                    <Pages.VariableList />
                </PermissionGuard>
            } />
        </Routes>
    );
};

export default VariablesRoute;
